import MainLayout from "@/components/layout/MainLayout";

const Terms = () => {
  return (
    <MainLayout>
      <div className="container-page max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-6">Условия использования</h1>
        
        <div className="bg-card rounded-lg border p-6 shadow-sm">
          <div className="prose prose-gray max-w-none">
            <p className="text-sm text-muted-foreground mb-6">
              Последнее обновление: {new Date().toLocaleDateString('ru-RU')}
            </p>
            
            <h2>1. Введение</h2>
            <p>
              Добро пожаловать в Voice2Doc. Используя наш сервис, вы соглашаетесь с настоящими Условиями использования. 
              Пожалуйста, внимательно прочитайте их.
            </p>
            
            <h2>2. Описание услуг</h2>
            <p>
              Voice2Doc предоставляет услуги по преобразованию аудио и видео файлов в текст с использованием 
              технологий искусственного интеллекта. Наши услуги включают транскрипцию аудио, обработку текста 
              и создание документов на основе шаблонов.
            </p>
            
            <h2>3. Учетная запись пользователя</h2>
            <p>
              Для использования сервиса необходимо создать учетную запись. Вы несете ответственность за 
              сохранение конфиденциальности своей учетной записи и пароля, а также за ограничение доступа к своему компьютеру.
              Вы соглашаетесь принять ответственность за все действия, которые происходят под вашей учетной записью.
            </p>
            
            <h2>4. Оплата и возврат средств</h2>
            <p>
              Оплата услуг производится путем приобретения пакетов минут. Неиспользованные минуты не сгорают и 
              остаются на вашем балансе до их использования. Возврат средств возможен в течение 14 дней с момента 
              покупки, если услуги не были использованы.
            </p>
            
            <h2>5. Конфиденциальность данных</h2>
            <p>
              Мы обрабатываем ваши данные в соответствии с нашей Политикой конфиденциальности. Загружая файлы 
              в наш сервис, вы предоставляете нам право обрабатывать их для предоставления услуг. Мы не используем 
              содержимое ваших файлов для других целей без вашего согласия.
            </p>
            
            <h2>6. Интеллектуальная собственность</h2>
            <p>
              Вы сохраняете все права на загружаемые файлы и созданные документы. Voice2Doc сохраняет права на 
              программное обеспечение, дизайн, логотипы и другие материалы, связанные с сервисом.
            </p>
            
            <h2>7. Ограничения использования</h2>
            <p>
              Запрещается использовать сервис для загрузки незаконного контента, нарушения прав третьих лиц, 
              распространения вредоносного ПО или попыток взлома системы. Мы оставляем за собой право приостановить 
              или прекратить доступ к сервису при нарушении этих условий.
            </p>
            
            <h2>8. Ограничение ответственности</h2>
            <p>
              Voice2Doc предоставляется "как есть" без каких-либо гарантий. Мы не несем ответственности за любые 
              прямые, косвенные, случайные или специальные убытки, возникшие в результате использования или 
              невозможности использования сервиса.
            </p>
            
            <h2>9. Изменения в условиях</h2>
            <p>
              Мы оставляем за собой право изменять эти условия в любое время. Продолжая использовать сервис после 
              внесения изменений, вы соглашаетесь с новыми условиями.
            </p>
            
            <h2>10. Применимое право</h2>
            <p>
              Настоящие условия регулируются и толкуются в соответствии с законодательством Российской Федерации.
            </p>
            
            <h2>11. Контактная информация</h2>
            <p>
              Если у вас есть вопросы или предложения относительно наших Условий использования, пожалуйста, 
              свяжитесь с нами по адресу: support@voice2doc.ru
            </p>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Terms;